import { axios } from "helper/axios";
import { jarvisPrimeOnboardingConstants } from "./jarvisPrimeOnboardingConstants";

const jarvisPrimeOnboardingApis = {};

jarvisPrimeOnboardingApis.sendEmailVerificationLink = ({ actionType, email }) => {
  return axios.post(jarvisPrimeOnboardingConstants.SEND_EMAIL_VERIFICATION_API, {
    actionType,
    email,
  });
};


jarvisPrimeOnboardingApis.getOnboardingData = () => {
  return axios.get(jarvisPrimeOnboardingConstants.PRIME_ONBOARDING_DATA_API);
};

// TODO: move this api to master
jarvisPrimeOnboardingApis.submitRiskAssessmentQuestions = ({
  questionAnswers,
}) => {
  return axios.post(jarvisPrimeOnboardingConstants.SUBMIT_RISK_ASSESSMENT_QUESTION_API, {
    questionAnswers,
  });
};

jarvisPrimeOnboardingApis.submitRiskProfile = ({
  riskId,
  riskManuallyChecked,
  suggestedRisk,
  productCode, }) => {
  return axios.post(
    jarvisPrimeOnboardingConstants.SUBMIT_PRIME_RISK_PROFILE_API,
    {
      riskId,
      riskManuallyChecked,
      suggestedRisk,
      productCode,
    }
  );
};

jarvisPrimeOnboardingApis.submitInvestment = ({
  investmentAmount,
  investmentTenure,
  investmentStrategy,
  planId,
}) => {
  return axios.post(jarvisPrimeOnboardingConstants.SUBMIT_PRIME_INVESTMENT_API, {
    investmentAmount,
    investmentTenure,
    investmentStrategy,
    planId,
  });
};

jarvisPrimeOnboardingApis.getPortfolioData = () => {
  return axios.get(jarvisPrimeOnboardingConstants.PRIME_PORTFOLIO_DATA_API);
};



jarvisPrimeOnboardingApis.getPricingData = ({ couponCode = "" } = {}) => {
  return axios.get(jarvisPrimeOnboardingConstants.PRICING_DATA_API, {
    params: { couponCode },
  });
};

jarvisPrimeOnboardingApis.verifyKYCData = ({
  customerId,
  dateOfBirth,
  inputIdType,
  inputIdNumber,
}) => {
  return axios.post(jarvisPrimeOnboardingConstants.VERIFY_KYC_API, {
    customerId,
    dateOfBirth,
    inputIdType,
    inputIdNo: inputIdNumber,
  });
};

jarvisPrimeOnboardingApis.uploadKYCImages = ({ customerId, typeKey, file, fileName }) => {
  const fd = new FormData();

  fd.append("customerId", customerId);
  fd.append(typeKey, file, fileName);

  return axios.post(jarvisPrimeOnboardingConstants.KYC_IMAGE_UPLOAD_API, fd);
};

jarvisPrimeOnboardingApis.reVerifyKYCData = ({
  customerId,
  panCardNumber,
  aadharCardNumber,
  dateOfBirth,
}) => {
  const body = {
    customerId,
    panCardNumber,
    aadharCardNumber,
    dateOfBirth,
  };
  return axios.post(jarvisPrimeOnboardingConstants.REVERIFY_KYC_API, body);
};

jarvisPrimeOnboardingApis.confirmInvestmentInfo = ({
  riskProfileId,
  investmentStrategy,
  investmentHorizon,
  investmentAmount,
  planId,
}) => {
  return axios.post(jarvisPrimeOnboardingConstants.PRIME_CONFIRM_INVESTMENT_INFO_API, {
    riskProfileId,
    investmentStrategy,
    investmentHorizon,
    investmentAmount,
    planId,
  });
};

export { jarvisPrimeOnboardingApis };
